import React from "react";

const pad = (n) => String(n).padStart(2, "0");
const H = Array.from({ length: 24 }, (_, i) => pad(i));
const MS = Array.from({ length: 60 }, (_, i) => pad(i));

const parse = (v) => {
  const s = String(v || "").trim();
  const parts = s.split(/[ T]/);
  const t = parts.length > 1 ? parts[parts.length - 1] : (s.includes(":") ? s : "");
  const d = parts.length > 1 ? parts[0] : (s.includes(":") ? "" : s);
  const [h = "", m = "", sec = ""] = t.split(":");
  return { d: /^\d{4}-\d{2}-\d{2}$/.test(d) ? d : "", h: pad(h || 0).slice(-2), m: pad(m || 0).slice(-2), s: pad(sec || 0).slice(-2), empty: !t };
};

// 24-hour EFD timestamp picker (HH:MM:SS, locale-independent). withDate adds a calendar date and blocks the future.
export function EfdTimeField({ value, onChange, withDate = false, testid = "efd-time" }) {
  const p = parse(value);
  const emit = (patch) => {
    const n = { ...p, ...patch };
    const t = `${n.h}:${n.m}:${n.s}`;
    onChange(withDate ? (n.d ? `${n.d} ${t}` : "") : t);
  };
  const sel = "h-9 rounded-sm border border-gray-300 bg-white px-1 text-sm font-mono focus:border-[#1B4383] focus:outline-none";
  const today = new Date().toISOString().slice(0, 10);
  return (
    <div className="mt-1 flex flex-wrap items-center gap-1" data-testid={testid}>
      {withDate && (
        <input type="date" max={today} className={`${sel} px-2`} data-testid={`${testid}-date`} value={p.d}
          onChange={(e) => emit({ d: e.target.value > today ? today : e.target.value })} />
      )}
      <select className={sel} data-testid={`${testid}-hh`} value={p.empty ? "" : p.h} onChange={(e) => emit({ h: e.target.value })}>
        <option value="" disabled>HH</option>{H.map((x) => <option key={x} value={x}>{x}</option>)}
      </select>:
      <select className={sel} data-testid={`${testid}-mm`} value={p.empty ? "" : p.m} onChange={(e) => emit({ m: e.target.value })}>
        <option value="" disabled>MM</option>{MS.map((x) => <option key={x} value={x}>{x}</option>)}
      </select>:
      <select className={sel} data-testid={`${testid}-ss`} value={p.empty ? "" : p.s} onChange={(e) => emit({ s: e.target.value })}>
        <option value="" disabled>SS</option>{MS.map((x) => <option key={x} value={x}>{x}</option>)}
      </select>
    </div>
  );
}
